import React from 'react';
import PropTypes from 'prop-types';
const IconTick = ({ width = 14, height = 12, viewBox = '0 0 15 12', color = '#1F1F1F' }) =>
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox={viewBox} fill='none'>
        <path d='M11.5 0.5L5 7L2 4L0.5 5.5L5 10L13 2L11.5 0.5Z' fill={color} />
    </svg>;
IconTick.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string,
    color: PropTypes.string
};
export default React.memo(IconTick);
